import { STRINGS } from '@/strings/strings';
import { cn } from '@/lib/utils';

export type SbMode = 'story' | 'explanation';

interface ModeSelectorProps {
  value: SbMode;
  onChange: (value: SbMode) => void;
}

export function ModeSelector({ value, onChange }: ModeSelectorProps) {
  const S = STRINGS.builder.sb;
  return (
    <div className="grid grid-cols-2 gap-3">
      <ModeButton
        active={value === 'story'}
        onClick={() => onChange('story')}
        label={S.modes.story}
        description={S.modeDescriptions.story}
      />
      <ModeButton
        active={value === 'explanation'}
        onClick={() => onChange('explanation')}
        label={S.modes.explanation}
        description={S.modeDescriptions.explanation}
      />
    </div>
  );
}

interface ModeButtonProps {
  active: boolean;
  onClick: () => void;
  label: string;
  description: string;
}

function ModeButton({ active, onClick, label, description }: ModeButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'flex min-h-11 flex-col items-start gap-1 rounded-lg p-3 text-left transition-colors',
        active ? 'border-[1.5px] border-dream-navy bg-dream-navy' : 'builder-field opacity-50',
      )}
    >
      <span className={cn('text-base', active ? 'font-bold text-dream-white' : 'text-dream-navy')}>
        {label}
      </span>
      <span
        className={cn(
          'text-xs leading-snug',
          active ? 'text-dream-white/80' : 'text-dream-navy/70',
        )}
      >
        {description}
      </span>
    </button>
  );
}
